import { environment } from '../../../environments/environments';

/**
 * Configuración centralizada de las URLs de las APIs para la aplicación.
 *
 * Centraliza el acceso a las rutas de los servicios backend obteniéndolas directamente
 * de las variables de entorno activas. Esto evita acoplar las URLs de los endpoints
 * en los servicios individuales y facilita la transición entre entornos (desarrollo, producción, etc.).
 *
 * @example
 * import { API_CONFIG } from 'src/app/core/api/api.config';
 * // Uso típico en un servicio:
 * const url = `${API_CONFIG.baseURL}/usuarios`;
 */
export const API_CONFIG = {
  /** * URL base principal para las peticiones al backend.
   * Su valor se inyecta dinámicamente desde `environment.apis.baseURL`.
   */
  baseURL: environment.apis.baseURL,
  imagenesURL: environment.apis.imagenesURL,
  archivosURL: environment.apis.archivosURL,
  descargasURL: environment.apis.descargasURL,
};
